import React from "react"

import { Box } from "@mui/material"

import { ErrorResponse, Loading, RestResponse } from "@sinossi/mates-react-library"

import { t } from "@lingui/macro"

import withUseRouter, { UseRouterParams } from "services/router"
import {
    PageHeader,
    PageSectionTitle,
    RoutesData,
} from "components/commons"
import {
    MatesComponent,
    MatesComponentState,
} from "components/mates-component"

import { UserTable } from "components/user/user-table/user-table"
import {
    Users, PaginatedResponse, UserRequest,
    SearchFilter,
    NewUserRequest
} from "../../models"
import { UserServices } from "../../services/user.services"
import NewUserModal from "../../components/user/new-user-modal/new-user-modal"
import { GeographicPermissionModal } from "../../components/user/geographic-permissions"

interface UserProps extends UseRouterParams {
}
interface UserState extends MatesComponentState {
    usersData: PaginatedResponse<Users> | null
    request: UserRequest
    loading: boolean
    openNewUser: boolean
    openGeographicPermissions: boolean
    selectedAccountId: string | null
}

class User extends React.Component<UserProps, UserState> {
    private readonly matesComponent: MatesComponent<UserProps, UserState> = new MatesComponent(this)

    constructor(props: any) {
        super(props);
        this.state = {
            ...this.matesComponent.setupState(),
            usersData: null,
            request: {
                pageSize: 10,
                pageId: 0,
                orderType: null,
                orderBy: null,
                firstName: null,
                lastName: null,
                city: null,
                accountType: null,
                disabled: false,
                vatCode: null,
                fiscalCode: null
            },
            loading: true,
            openNewUser: false,
            openGeographicPermissions: false,
            selectedAccountId: null
        }
    }

    componentDidMount() {
        this.filterUser()
        // Registra la funzione globale per aprire i permessi geografici
        ;(window as any).openGeographicPermissions = this.openGeographicPermissions
    }

    componentWillUnmount() {
        // Pulisce la funzione globale
        delete (window as any).openGeographicPermissions
    }

    private filterUser = () => {
        UserServices.usersData(this.state.request, this.usersDataCallback, this.matesComponent.onException)
    }

    private usersDataCallback = (response: RestResponse<PaginatedResponse<Users>, ErrorResponse>) => {
        if (response.hasError()) {
            this.matesComponent.onError(response)
            return
        }

        this.setState(() => ({
            usersData: response.data,
            loading: false
        }))
    }

    private paginationUpdate = (request: SearchFilter) => {

        this.setState(() => ({
            request: {
                ...this.state.request,
                pageSize: request.pageSize,
                pageId: request.pageId,
            }
        }), () => this.filterUser())

    }

    private openNewUser = () => {
        this.setState(() => ({
            openNewUser: true
        }))
    }

    private closeNewUser = () => {
        this.setState(() => ({
            openNewUser: false
        }))
    }

    private createUser = (request: NewUserRequest) => {

        this.setState(() => ({
            loading: true
        }))


        this.closeNewUser()


        UserServices.createUser(request, this.createCallback, this.createErrorCallback)
    }

    private createErrorCallback = (response: any) => {

        this.setState(() => ({
            loading: false
        }))

        this.matesComponent.onError(response);
    }

    private createCallback = (response: any) => {

        this.setState(() => ({
            loading: false
        }))

        if (response.hasError()) {
            this.matesComponent.onError(response)
            return
        }

        this.filterUser();
    }

    private openGeographicPermissions = (accountId: string) => {
        this.setState({
            openGeographicPermissions: true,
            selectedAccountId: accountId
        })
    }

    private closeGeographicPermissions = () => {
        this.setState({
            openGeographicPermissions: false,
            selectedAccountId: null
        })
    }

    private handleToggleSuperAdmin = (accountId: string, isSuperAdmin: boolean) => {
        this.setState({ loading: true })
        
        UserServices.toggleSuperAdmin(
            accountId, 
            isSuperAdmin, 
            this.toggleSuperAdminCallback, 
            this.toggleSuperAdminErrorCallback
        )
    }

    private toggleSuperAdminCallback = (response: any) => {
        this.setState({ loading: false })
        
        if (response.hasError()) {
            this.matesComponent.onError(response)
            return
        }
        
        // Ricarica i dati per aggiornare la tabella
        this.filterUser()
    }

    private toggleSuperAdminErrorCallback = (response: any) => {
        this.setState({ loading: false })
        this.matesComponent.onError(response)
    }

    render() {
        return (
            <Box sx={{ width: '100%', pt: 2, position: "relative" }}>
                <Loading show={this.state.loading} />
                <PageHeader
                    title={RoutesData.USER.title}
                    paths={[RoutesData.DASHBOARD, RoutesData.USER]}
                    addButtonModal={t({ id: "add-new-user", message: "Aggiungi utente" })}
                    onClickButtonModal={this.openNewUser}
                />

                {/*<UserAdvancedSearch/>*/}
                {!this.state.loading && <>
                    <Box sx={{ mt: 3 }}>
                        <PageSectionTitle title={t({ id: "user-user-title-table", message: "I tuoi Utenti" })} />
                        {
                            this.state.usersData &&
                            <UserTable
                                data={this.state.usersData}
                                handleCallback={this.paginationUpdate}
                                onToggleSuperAdmin={this.handleToggleSuperAdmin} />
                        }

                    </Box>
                </>}

                {
                    this.state.openNewUser &&
                    <NewUserModal onClose={this.closeNewUser} submit={this.createUser} />
                }

                {
                    this.state.openGeographicPermissions && this.state.selectedAccountId &&
                    <GeographicPermissionModal
                        open={this.state.openGeographicPermissions}
                        accountId={this.state.selectedAccountId}
                        onClose={this.closeGeographicPermissions}
                    />
                }
            </Box >
        )
    }
}

export default withUseRouter(User)
